import axiosPrivate from "./axiosPrivate";

const getNotificaciones = (periodo) => {
  const params = periodo ? `?periodo=${periodo}` : '';
  return axiosPrivate.get(`getNotificaciones${params}`)
    .then(res => res.data);
};

const marcarNotificacionLeida = (data) => {
  return axiosPrivate.post("marcarNotificacionLeida", data)
    .then(res => res.data);
};

const conteoNoLeidas = () => {
  return axiosPrivate.get("conteoNoLeidas")
    .then(res => res.data);
};

export default {
  getNotificaciones,
  marcarNotificacionLeida,
  conteoNoLeidas,
};
